"use strict";
import React from "react";
import { Translation } from "../Translation";
export function ErrorShow({ error, errorInfo }) {
  return /* @__PURE__ */ React.createElement("div", { className: "container", style: { padding: "64px" } }, /* @__PURE__ */ React.createElement("h2", null, /* @__PURE__ */ React.createElement(Translation, null, "An unexpected error happened")), /* @__PURE__ */ React.createElement("details", { style: { whiteSpace: "pre-wrap" } }, error && error.toString(), /* @__PURE__ */ React.createElement("br", null), errorInfo && errorInfo.componentStack));
}
